import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { BaseComponent } from '@classes/extends';
import { HistoData, HistoGalaComponent, HistoGalaComponentData } from '@composants/histo-gala/histo-gala.component';
import { Client, ClientsService as ClientService, DonneesGen, FicheclientService as FicheClientService, LaiterieFiche, Qualite, RFService, Service } from '@estel-numerique/galaclick-api';
import { ValidatorDateService, ValidatorPatternService, PipesModule } from '@estel-numerique/galaclick-core';
import { MilliersPipe } from '@services/index';
import { Constantes } from '@services/util/constantes';
import { lastValueFrom } from 'rxjs';
import { CreerService, CreerServiceData } from 'src/app/suiviclients/services/services-creer/services-creer.component';
import { FicheClientEngagementsComponent, FicheClientEngagementsComponentData } from './ficheclient-engagements/ficheclient-engagements.component';
import { FicheClientLaiteriesComponent, FicheClientLaiteriesComponentData } from './ficheclient-laiteries/ficheclient-laiteries.component';
import { AddButton, SearchButton } from '../../../composants/composants';
import { ButtonGalaEditComponent } from '../../../composants/buttons/btn-gala-edit/btn-gala-edit.component';
import { ButtonGalaSearchComponent } from '../../../composants/buttons/btn-gala-search/btn-gala-search.component';
import { ButtonGalaDeleteComponent } from '../../../composants/buttons/btn-gala-delete/btn-gala-delete.component';
import { DateFormatPipe } from '../../../../services/util/pipe';



@Component({
    selector: 'client-donnees-gen',
    templateUrl: 'ficheclient-donneesgen.component.html',
    imports: [AddButton, ButtonGalaEditComponent, ButtonGalaSearchComponent, SearchButton, ButtonGalaDeleteComponent, PipesModule, DateFormatPipe]
})
export class FicheClientDonneesGenComponent extends BaseComponent {
    public validDate = inject(ValidatorDateService);
    public validPattern = inject(ValidatorPatternService);
    private formBuilder = inject(UntypedFormBuilder);
    private wsFicheClient = inject(FicheClientService);
    private wsClient = inject(ClientService);
    public milliersPipe = inject(MilliersPipe);
    private dialog = inject(MatDialog);

    public codeModule: string = Constantes.CodeOption.CFICHECLIENT;

    protected readonly Constantes = Constantes;

    @Input() public titre: string;

    @Output() public rfService = new EventEmitter();
    @Output() public service = new EventEmitter();
    @Output() public installations = new EventEmitter();

    public donneesGen: DonneesGen;
    public clientSelectionne: Client;
    public services: Service[] = [];
    public formAjout: UntypedFormGroup;
    public listRfServices: RFService[] = [];
    public listeHistoLaiteries: LaiterieFiche[] = [];
    public listeHistoEngagements: Qualite[] = [];

    protected lgTrad: Record<string, string>;

    constructor() {
        super();
        this.formAjout = this.formBuilder.group({
            TYPESERV: [null, [Validators.required]]
        });
        this.lgTrad = {
            SERVACTIFS: this.translate.instant("APPFICHECLIENT.COLTAB.SERVACTIFS"),
            SERV: this.translate.instant("SERV"),
            INFORMATIONS: this.translate.instant("INFORMATIONS"),
            INSTALLACT: this.translate.instant("APPFICHECLIENT.COLTAB.INSTALLACT"),
            INSTALLATION: this.translate.instant("INSTALLATION"),
            POSTES: this.translate.instant("APPFICHECLIENT.COLTAB.POSTES"),
            LAITERIES: this.translate.instant("APPFICHECLIENT.COLTAB.LAITERIES"),
            ENGAGEMENTS: this.translate.instant("APPFICHECLIENT.COLTAB.ENGAGEMENTS"),
            HISTOQLT: this.translate.instant("APPFICHECLIENT.HISTOQLT"),
            HISTOLAIT: this.translate.instant("APPFICHECLIENT.HISTOLAIT"),
            NOM: this.translate.instant("NOM"),
            MARQ: this.translate.instant("MARQ"),
            MOD: this.translate.instant("MOD"),
            RET: this.translate.instant("RET"),
            DEBUT: this.translate.instant('DEBUT'),
            FIN: this.translate.instant('FIN'),
        };
    }


    // =========================================================================
    // CHARGEMENT CONTEXTE
    // =========================================================================

    async initialiseDonneesGenerales(donneesGen: DonneesGen, idClient: number) {
        this.donneesGen = donneesGen;
        this.clientSelectionne = await lastValueFrom(this.wsClient.getClientByID(idClient));
        await this.initListe();
    }

    async initListe() {
        try {
            this.listRfServices = await lastValueFrom(this.wsCacheLow.getRFServices());
            this.donneesGen.LAITERIES.forEach((laiterie: LaiterieFiche) => {
                this.setInformationsLaiteries(laiterie);
            });

        } catch (e) {
            this.util.fErreur(e);
        }

    }

    public setInformationsLaiteries(laiterie: LaiterieFiche) {
        if (laiterie.ORGANISME.IDORGA > -1 && laiterie.REFANNUELLE) {
            laiterie.INFORMATIONS = "Référence annuelle : " + this.milliersPipe.transform(laiterie.REFANNUELLE) + " L";
        } else {
            if (laiterie.VALORISATION && laiterie.VOLUME) {
                laiterie.INFORMATIONS = "Volume annuel : " + this.milliersPipe.transform(laiterie.VOLUME) + " L, Valorisation annuelle : "
                    + this.milliersPipe.transform(laiterie.VALORISATION) + " €/1 000L";
            } else if (laiterie.VOLUME) {
                laiterie.INFORMATIONS = "Volume annuel : " + this.milliersPipe.transform(laiterie.VOLUME) + " L";

            }
        }
    }

    public openCreerService() {
        if (this.droitsAccess.write) {
            const listRfServiceCopy = Object.assign([], this.listRfServices);
            for (let idx = this.listRfServices.length - 1; idx >= 0; idx--) {
                for (const elem of this.donneesGen.SERVICES) {
                    //on ne veut afficher que les services qui ne sont pas déjà actifs
                    if (this.listRfServices[idx].CODESERV == elem.TYPESERVICE.CODESERV) {
                        listRfServiceCopy.splice(idx, 1);
                        break;
                    }
                }
            }
            const dialogCreer = this.dialog.open(CreerService, {
                data: {
                    listeTypeServ: listRfServiceCopy,
                    client: this.clientSelectionne
                } as CreerServiceData
            });
            dialogCreer.componentInstance.rfService.subscribe((rfservice) => {
                this.emitRfService(rfservice);
            });

        } else {
            this.util.fErreur(this.translate.instant("ACCESFONCTIONINTERDIT"));
        }
    }

    public emitService(service: Service) {
        this.service.emit(service);
    }

    public emitRfService(rfService: RFService) {
        this.rfService.emit(rfService);
    }

    public emitInstallations() {
        this.installations.emit();
    }

    public openLaiteries() {
        const dialotLait = this.dialog.open(FicheClientLaiteriesComponent, {
            data: {
                idClient: this.clientSelectionne.IDCLIENT,
                listLaiteriesClient: this.donneesGen.LAITERIES
            } as FicheClientLaiteriesComponentData
        });
        dialotLait.componentInstance.saved.subscribe((laiterie) => {
            this.savedLaiterie(laiterie);
        });
    }

    public updateLaiterie(laiterie: LaiterieFiche) {
        const dialotLait = this.dialog.open(FicheClientLaiteriesComponent, {
            data: {
                idClient: this.clientSelectionne.IDCLIENT,
                listLaiteriesClient: this.donneesGen.LAITERIES,
                laiterie: laiterie
            } as FicheClientLaiteriesComponentData
        });
        dialotLait.componentInstance.saved.subscribe((laiterieSauvee) => {
            this.savedLaiterie(laiterieSauvee);
        });
    }

    public savedLaiterie(laiterie: LaiterieFiche) {
        if (laiterie.IDLAITERIE) {
            this.donneesGen.LAITERIES.forEach((indexLaiterie: LaiterieFiche) => {
                if (indexLaiterie.ORGANISME.IDORGA == laiterie.ORGANISME.IDORGA) {
                    this.donneesGen.LAITERIES.splice(this.donneesGen.LAITERIES.indexOf(indexLaiterie), 1);
                }
            });
            this.savedLait(laiterie);
        } else {
            this.savedTransfo(laiterie);
        }
    }

    public savedLait(laiterie: LaiterieFiche) {
        const index = this.donneesGen.LAITERIES.findIndex((lait: LaiterieFiche) => {
            return lait.IDLAITERIE == laiterie.IDLAITERIE;
        });
        if (index > -1) {
            if (!this.util.date.compareTodayDate(laiterie.DDEBUT, laiterie.DFIN, false)) {
                this.donneesGen.LAITERIES.splice(index, 1);
            } else {
                this.donneesGen.LAITERIES.splice(index, 1, laiterie);
            }
        } else {
            this.donneesGen.LAITERIES.push(laiterie);
        }
    }

    public savedTransfo(laiterie: LaiterieFiche) {
        const index = this.donneesGen.LAITERIES.findIndex((lait: LaiterieFiche) => {
            return lait.IDTRANSFO == laiterie.IDTRANSFO;
        });
        if (index > -1) {
            if (!this.util.date.compareTodayDate(laiterie.DDEBUT, laiterie.DFIN, false)) {
                this.donneesGen.LAITERIES.splice(index, 1);
            } else {
                this.donneesGen.LAITERIES.splice(index, 1, laiterie);
            }
        } else {
            this.donneesGen.LAITERIES.push(laiterie);
        }
    }

    public async openHistoLaiteries() {
        try {
            this.util.showLoader();
            this.listeHistoLaiteries = await lastValueFrom(this.wsFicheClient.getLaiteriesHisto(this.clientSelectionne.IDCLIENT));

            this.listeHistoLaiteries.forEach((laiterie: LaiterieFiche) => {
                this.setInformationsLaiteries(laiterie);
            });
            const oData: HistoGalaComponentData = {
                titre: this.lgTrad.HISTOLAIT,
                entete: { nom: this.lgTrad.NOM, info: this.lgTrad.INFORMATIONS },
                liste: this.listeHistoLaiteries.map((el) => {
                    return {
                        nom: el.ORGANISME.NOM,
                        info: el.INFORMATIONS,
                        debut: el.DDEBUT,
                        fin: el.DFIN,
                    } as HistoData;
                })
            };
            this.dialog.open(HistoGalaComponent, { data: oData });
        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }
    }

    public openEngagements() {
        const dialogQualite = this.dialog.open(FicheClientEngagementsComponent, {
            data: {
                idClient: this.clientSelectionne.IDCLIENT,
                listeQualite: this.donneesGen.QUALITES
            } as FicheClientEngagementsComponentData
        });
        dialogQualite.componentInstance.saved.subscribe((qualite) => {
            this.savedEngagement(qualite);
        });
    }

    public deleteEngagement(qlt: Qualite) {
        const dialogQualite = this.dialog.open(FicheClientEngagementsComponent, {
            data: {
                idClient: this.clientSelectionne.IDCLIENT,
                listeQualite: this.donneesGen.QUALITES,
                qualite: qlt
            } as FicheClientEngagementsComponentData
        });
        dialogQualite.componentInstance.saved.subscribe((qualite) => {
            this.savedEngagement(qualite);
        });
    }

    public savedEngagement(qlt: Qualite) {
        const index = this.donneesGen.QUALITES.findIndex((q: Qualite) => {
            return q.IDENGAGEMENT == qlt.IDENGAGEMENT;
        });
        if (index > -1) {
            if (!this.util.date.compareTodayDate(qlt.DDEBUT, qlt.DFIN, false)) {
                this.donneesGen.QUALITES.splice(index, 1);
            } else {
                this.donneesGen.QUALITES.splice(index, 1, qlt);
            }
        } else {
            this.donneesGen.QUALITES.push(qlt);
        }
    }

    public async openHistoEngagements() {
        try {
            this.util.showLoader();
            this.listeHistoEngagements = await lastValueFrom(this.wsFicheClient.getEngagementsQltHisto(this.clientSelectionne.IDCLIENT));
            const oData: HistoGalaComponentData = {
                titre: this.lgTrad.HISTOQLT,
                liste: this.listeHistoEngagements.map((el) => {
                    return {
                        nom: el.RFQUALITE.QUALITE,
                        debut: el.DDEBUT,
                        fin: el.DFIN,
                    } as HistoData;
                })
            };
            this.dialog.open(HistoGalaComponent, { data: oData });
        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }
    }

    public hasAccessEditServices() {
        return this.hasAccesModule(Constantes.CodeOption.CGESTIONSERV);
    }
}
